import { CSSProperties } from 'react';

export const MessagePosition = {
  TOP_RIGHT: 'top-right',
  TOP_CENTER: 'top-center',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_CENTER: 'bottom-center',
  CENTER: 'center',
} as const;

export type MessagePositionType = (typeof MessagePosition)[keyof typeof MessagePosition];

export type MessageDirection = Extract<CSSProperties['flexDirection'], 'column' | 'column-reverse'>;
